const prefix = "shopping/rfq";

export const FETCH_RFQ = `${prefix}/FETCH_RFQ`;
export const FETCH_RFQ_START = `${prefix}/FETCH_RFQ_START`;
export const FETCH_RFQ_SUCCESS = `${prefix}/FETCH_RFQ_SUCCESS`;
export const FETCH_RFQ_FAIL = `${prefix}/FETCH_RFQ_FAIL`;

export const PATCH_RFQ = `${prefix}/PATCH_RFQ`;
export const PATCH_RFQ_START = `${prefix}/PATCH_RFQ_START`;
export const PATCH_RFQ_SUCCESS = `${prefix}/PATCH_RFQ_SUCCESS`;
export const PATCH_RFQ_FAIL = `${prefix}/PATCH_RFQ_FAIL`;

export const PATCH_RFQ_POSITION = `${prefix}/PATCH_RFQ_POSITION`;
export const PATCH_RFQ_POSITION_START = `${prefix}/PATCH_RFQ_POSITION_START`;
export const PATCH_RFQ_POSITION_SUCCESS = `${prefix}/PATCH_RFQ_POSITION_SUCCESS`;
export const PATCH_RFQ_POSITION_FAIL = `${prefix}/PATCH_RFQ_POSITION_FAIL`;

export const SUBMIT_RFQ = `${prefix}/SUBMIT_RFQ`;
export const SUBMIT_RFQ_START = `${prefix}/SUBMIT_RFQ_START`;
export const SUBMIT_RFQ_SUCCESS = `${prefix}/SUBMIT_RFQ_SUCCESS`;
export const SUBMIT_RFQ_FAIL = `${prefix}/SUBMIT_RFQ_FAIL`;

/**
 * Fetch rfq data.
 * @param {string} rfqId
 * @returns {{type: string, payload: object}}
 */
export const fetchRfq = (rfqId) => ({ type: FETCH_RFQ, payload: rfqId, meta: { thunk: true } });

/**
 * Partial update to rfq record.
 * @param {string} rfqId - The rfq id.
 * @param {object} data - The patch record.
 * @returns {{type: string, payload: object}}
 */
export const patchRfq = (rfqId, data) => ({ type: PATCH_RFQ, payload: { rfqId, data }, meta: { thunk: true } });

/**
 * Partial update to rfq position record.
 * @param {string} rfqId - The rfq id.
 * @param {string} positionId - The rfq position id.
 * @param {object} data - The patch data.
 * @returns {{type: string, payload: object}}
 */
export const patchRfqPosition = (rfqId, positionId, data) => ({ type: PATCH_RFQ_POSITION, payload: { rfqId, positionId, data }, meta: { thunk: true } });

/**
 * Submit an rfq.
 * @param {string} rfqId - The rfq id.
 * @param {object} data - Flags for submission.
 * @returns {{type: string, payload: {rfqId: *, data: *}, meta: {thunk: boolean}}}
 */
export const submitRfq = (rfqId, data) => ({ type: SUBMIT_RFQ, payload: { rfqId, data }, meta: { thunk: true } });
